import { chatsApi } from '../../api/chats'
import { useUiStore } from '../../stores/uiStore'

interface PinnedEntry {
  id: string
  message_id: string
  chat_id: string
  pinned_at: string
  pinned_by: string
  message?: {
    id: string
    text?: string
  }
}

interface Props {
  chatId: string
  pinned: PinnedEntry[]
  onUnpin: (messageId: string) => void
}

export function PinnedMessageBanner({ chatId, pinned, onUnpin }: Props) {
  const { addToast } = useUiStore()

  if (!pinned.length) return null

  const latest = pinned[pinned.length - 1]
  const preview = latest.message?.text
    ? latest.message.text.length > 60
      ? latest.message.text.slice(0, 60) + '…'
      : latest.message.text
    : 'Закреплённое сообщение'

  const handleUnpin = async () => {
    try {
      await chatsApi.unpinMessage(chatId, latest.message_id)
      onUnpin(latest.message_id)
    } catch {
      addToast('error', 'Не удалось открепить сообщение')
    }
  }

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-bg-primary border-b border-divider shrink-0">
      <div className="w-0.5 h-8 bg-accent rounded-full shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-accent text-xs font-semibold">Закреплённое сообщение</p>
        <p className="text-txt-secondary text-sm truncate">{preview}</p>
      </div>
      <button
        onClick={handleUnpin}
        className="text-txt-meta hover:text-txt-primary transition-colors shrink-0 p-1"
        title="Открепить"
        aria-label="Открепить сообщение"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  )
}
